import { ObjectType } from '@/@types/graphql-types';
import { useArbitrage } from '@/helpers/composables/useArbitrage';
import { getVm } from '@/helpers/vm-helper';

export enum BuyBoxFilterOptions {
	BEST = 'all',
	SUBSCRIPTION = 'flatrate',
	FREE = 'free',
	FAST_TV = 'fast',
	BUY = 'buy',
	RENT = 'rent',
}

export const buyboxExp2Validation = (
	objectType: ObjectType,
	isLoggedIn: boolean,
	isTitleUpcoming: boolean,
	offers: any[],
	onlyHasCinemaOffers: boolean | undefined,
	isBuyboxRevampExperiment: boolean
) => {
	const { isArbitrating } = useArbitrage();

	const currentExperiments = getVm()?.$store?.getters?.['experiment/activeVariantsWithControlGroup'];
	const experimentsToCheck = ['APPLE_FREE_TRIAL_FEATURE_EXP_2', 'POPULAR-PROVIDER-PAGE-EXP_4'];

	for (const experimentName in currentExperiments) {
		if (experimentsToCheck.includes(experimentName)) {
			if (currentExperiments[experimentName]) return false;
		} else {
			return (
				objectType === ObjectType.Movie &&
				!isLoggedIn &&
				!isTitleUpcoming &&
				offers.length > 0 &&
				!onlyHasCinemaOffers &&
				isBuyboxRevampExperiment &&
				!isArbitrating.value
			);
		}
	}
};
